import React, { useEffect, useState } from "react";
import classNames from "classnames";
import Check from "assets/images/icons/Check.svg";
import Exclamation from 'assets/images/icons/JSX/Exlamation';
import classes from "./style.module.scss";
import sharedClasses from "../style.module.scss";

export default ({
    input = {},
    notesInput = {},
    hideLabel = false,
    label = "",
    name,
    className,
    disabled,
    image,
    reset = false,
    dimensions = {},
}) => {
    const { value, onChange } = input;
    const { width = "380px", height = "200px", isWideThreshold, isWideLimit, crop = false } = dimensions;
    const { displayNotes = false, notes = "" } = notesInput;
    
    const [isFocused, toggleFocus] = useState(false);
    const [imgIsWide, setImgIsWide] = useState(false);

    const containerClassNamesList = [
        classes.checkboxWithImageContainer,
        disabled && classes.disabled,
        isFocused && classes.focused,
    ].filter((c) => c);

    const checkboxClassNamesList = [
        className && className,
        classes.checkboxWrapper,
        sharedClasses.inputField,
        disabled && classes.disabled,
    ].filter((c) => c);

    useEffect(() => {
        if (reset) {
            onChange(false);
        }
    }, [reset]);

    useEffect(() => {
        const img = new Image();
        img.src = image;
        img.onload = function () {
            // Access naturalWidth and naturalHeight for original dimensions
            const naturalWidth = this.naturalWidth;
            const naturalHeight = this.naturalHeight;
            
            if (isWideThreshold) {
                setImgIsWide(naturalWidth > naturalHeight + isWideThreshold);
            }
            else if (isWideLimit) {
                setImgIsWide(naturalHeight / naturalWidth < isWideLimit);
            }
        };
    }, [image, isWideLimit]);

    return (
        <div
            className={containerClassNamesList.join(" ")}
            onClick={(e) => {
                e.preventDefault();
                onChange(!value);
            }}
            onKeyDown={(e) => {
                // If enter is pressed, toggle check
                if (e.key === "Enter") {
                    onChange(!value);
                }
            }}
        >
            <div
                className={classes.imageContainer}
                style={{ width: width, height: height }}
            >
                <div
                    className={classNames({
                        [classes.centeredCroppedImage]: crop,
                        [classes.fullImage]: !crop}
                    )}
                    // style={{ width: width, height: height }}
                >
                    <img
                        src={`${image}`}
                        className={imgIsWide ? classes.wideImage : classes.tallImage}
                    />
                </div>
            </div>
            {displayNotes && (
                <div 
                    className={classNames(classes.notesContainer, {[classes.warningContainer]: !notes})}
                    style={{ width: width }}
                >
                    {notes && <p className={classes.notes}>{notes}</p>}
                    {!notes && (<span className={classes.warning}><Exclamation /> No description was provided in the image notes </span>)}
                </div>
            )}
            <label
                className={checkboxClassNamesList.join(" ")}
                htmlFor={name}
            >
                <input
                    value={value}
                    onChange={(e) => onChange(!value)} // Idk why, but when I use e.target.value, it's just throws only true or false ¯\_(ツ)_/¯
                    disabled={disabled}
                    name={name}
                    id={name}
                    className={classes.checkboxInput}
                    type="checkbox"
                    onFocus={() => toggleFocus(true)}
                    onBlur={() => toggleFocus(false)}
                />
                <div className={classes.checkbox}>{value && <img src={Check} alt="Checkmark" />}</div>
                <div className={`${sharedClasses.label} ${classes.label} ${hideLabel ? "invisible" : ""}`} htmlFor={name}>
                    {label}
                </div>
            </label>
        </div>
    );
};
